import WorkplaceImage from '../images/liskov-journey/workplace-animals.png'

const WorkplaceImageComponent = () => {
    return (
        <div className='classroom-image-component'>
            <img src={WorkplaceImage} alt="Post Liskov workplace in cartoon form" />
        </div>
    );
};

export default WorkplaceImageComponent;